export const getRequestLoginSecret = (uuid: string): string =>
  String(uuid).split('').reverse().join('');

export async function hashSecret(secret: string): Promise<Uint8Array> {
  const data = new TextEncoder().encode(String(secret));
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
  return new Uint8Array(hashBuffer);
}

function bytesToBase64(bytes: Uint8Array): string {
  let binary = '';

  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return btoa(binary);
}

export async function generateEncryptedTimestamp(
  key: Uint8Array
): Promise<string> {
  const nowUnixSec = Math.floor(Date.now() / 1000);

  const json = JSON.stringify({ createdDateUnixTime: nowUnixSec });
  const plainBytes = new TextEncoder().encode(json);

  const iv = window.crypto.getRandomValues(new Uint8Array(16));

  const keyBuffer = key.buffer.slice(
    key.byteOffset,
    key.byteOffset + key.byteLength
  ) as ArrayBuffer;

  const plainBuffer = plainBytes.buffer.slice(
    plainBytes.byteOffset,
    plainBytes.byteOffset + plainBytes.byteLength
  ) as ArrayBuffer;

  const cryptoKey = await window.crypto.subtle.importKey(
    'raw',
    keyBuffer,
    { name: 'AES-CBC' },
    false,
    ['encrypt']
  );

  const encrypted = await window.crypto.subtle.encrypt(
    { name: 'AES-CBC', iv },
    cryptoKey,
    plainBuffer
  );

  const ciphertext = new Uint8Array(encrypted);

  const result = new Uint8Array(iv.length + ciphertext.length);
  result.set(iv, 0);
  result.set(ciphertext, iv.length);

  return bytesToBase64(result);
}

export async function generateEncryptedTotp(
  uuid?: string | null,
  requestKeyReady?: string
): Promise<{ success: true; data: string } | { success: false; error: string }> {
  try {
    const keySecret = requestKeyReady || (uuid ? getRequestLoginSecret(uuid) : '');
    const requestKey = await hashSecret(keySecret);
    const encryptedTimestamp = await generateEncryptedTimestamp(requestKey);

    return { success: true, data: encryptedTimestamp };
  } catch {
    return { success: false, error: 'Unable to generate Totp' };
  }
}